import React, { FC } from 'react';
import { BooleanFieldFilter } from 'components/organisms/tasks/filters/boolean';
import { BooleanFiltertoHandlebarOperatorsMap } from './hb-operators-map';
import { getFieldPathForConditionalVariable } from './utils';

export const BooleanFilterToText: FC<{ filter: BooleanFieldFilter }> = ({
  filter,
}) => {
  const { field, type } = filter;

  return (
    <>{`${
      BooleanFiltertoHandlebarOperatorsMap[type] ?? type
    } ${getFieldPathForConditionalVariable(field)}`}</>
  );
};
